import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  exist: false,
  alignment: "center",
  position: "outside",
  customizeText: false,
};

export const dataLabelSlice = createSlice({
  name: "dataLabel",
  initialState,
  reducers: {
    updateDataLabelExist: (state, action) => {
      return {
        ...state,
        exist: !state.exist,
      };
    },
    updateDataLabelAlignmentPosition: (state, action) => {
      return {
        ...state,
        alignment: action.payload.alignment,
        position: action.payload.position,
      };
    },
    updateDataLabelCustomizeText: (state, action) => {
      return {
        ...state,
        customizeText: !state.customizeText,
      };
    },
  },
});

export const {
  updateDataLabelExist,
  updateDataLabelAlignmentPosition,
  updateDataLabelCustomizeText,
} = dataLabelSlice.actions;

export default dataLabelSlice.reducer;
